import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, inject, NgModule, provideAppInitializer } from '@angular/core'
import { MatSidenavModule } from '@angular/material/sidenav'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
// import { OpenIDImplicitFlowConfiguration, OidcSecurityService, OidcConfigService, AuthModule, LogLevel, StsConfigHttpLoader, StsConfigLoader } from 'angular-auth-oidc-client'
import { AbstractSecurityStorage, AuthModule } from 'angular-auth-oidc-client'

import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http'
import { ReactiveFormsModule } from '@angular/forms'
import { Router } from '@angular/router'
import { FormlyModule } from '@ngx-formly/core'
import { FormlyMaterialModule } from '@ngx-formly/material'
import * as Sentry from '@sentry/angular'
import { StartupClass } from 'app/core/services/app-loader.service'
import { AuthLocalStorageService } from 'app/core/services/auth-local-storage.service'
import { SharedModule } from 'app/shared/shared.module'
import { NgxSpinnerModule } from 'ngx-spinner'
import { BtLayoutComponent } from './_layout/bt-layout/bt-layout.component'
import { LayoutComponent } from './_layout/layout/layout.component'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { AuthConfigModule } from './auth-config.module'
import { CoreModule } from './core/core.module'
import { LatencyToolsModule } from './latency-tools/latency-tools.module'
import Aura from '@openng/optimus-ui-themes/aura'
import { provideOptimus } from '@openng/optimus-ui/config'

// import { ModalModule } from 'ngx-bootstrap/modal'
@NgModule({
    declarations: [AppComponent, LayoutComponent, BtLayoutComponent],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [AuthModule],
    imports: [
        AuthConfigModule,
        AppRoutingModule,
        BrowserModule,
        SharedModule,
        MatSidenavModule,
        LatencyToolsModule,
        BrowserAnimationsModule,
        NgxSpinnerModule,
        ReactiveFormsModule,
        FormlyModule.forRoot(),
        FormlyMaterialModule,
        CoreModule
    ],
    providers: [
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false
            })
        },
        {
            provide: Sentry.TraceService,
            deps: [Router]
        },
        provideAppInitializer(async () => {
            const startupClass = inject(StartupClass)
            return await startupClass.load()
        }),
        { provide: AbstractSecurityStorage, useClass: AuthLocalStorageService },
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        provideOptimus({
            theme: {
                preset: Aura,
                options: {
                    prefix: 'p',
                    darkModeSelector: 'system',
                    cssLayer: false
                }
            }
        })
    ]
})
export class AppModule {}
